/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import {
  ChannelDTO,
  ChecklistDTO,
  FormDTO,
  NoteDTO,
  PositionDTO,
  SurveyDTO,
  UserDataDTO
} from '@api/models';
import { ApiResParserService } from '@api/services/api-res-parser/api-res-parser.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiResParserCustomService extends ApiResParserService {
  constructor() {
    super();
  }

  generic<T>(res: any): T {
    return res;
  }

  userData(res: any): UserDataDTO {
    return res;
  }

  position(res: any): PositionDTO {
    res = this.cleanPayload(res);

    res.tuple = [res.product];

    return res;
  }

  forms(res: any): FormDTO[] {
    return res;
  }

  surveys(res: any): SurveyDTO[] {
    return (res && res.surveys) || [];
  }

  checklist(res: any): ChecklistDTO {
    return this.cleanPayload(res);
  }

  notes(res: any): NoteDTO[] {
    return this.cleanPayload(res);
  }

  channel(res: any): ChannelDTO {
    return this.cleanPayload(res);
  }
}
